// extracted by mini-css-extract-plugin
module.exports = {"arrow":"_1HSaW","left-arrow":"_1OZtt","right-arrow":"_3AIJ7","indicators":"HMBkL","indicator-button":"_1GeeG","active":"_1Ytyl","indicator":"_2c3zV"};